module.exports = __webpack_public_path__ + "media/images/career_camp/2022/hero/m5-3f001ee0d1bd6d45a33a23936bc703d4.svg";